import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getPickups,
    updatePickup
}

function getPickups(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/pickups`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updatePickup(pickupId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/pickups/${pickupId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}